import { ColumnFiltersState } from '@tanstack/react-table';

const OBJECT_SEPARATOR = ';';
const ARRAY_SEPARATOR = '|';
const KEY_VALUE_SEPARATOR = ':';

// This function lives out by itself to avoid issues with nuqs server/client
// code and next js
const serializeValue = (value: unknown): string => {
  if (value === null) return 'null';
  if (value === undefined) return 'undefined';

  if (Array.isArray(value)) {
    return value.map(serializeValue).join(ARRAY_SEPARATOR);
  }

  if (typeof value === 'object') {
    return Object.entries(value)
      .filter(([, val]) => !!val)
      .map(([key, val]) => [key, serializeValue(val)])
      .map((entry) => entry.join(OBJECT_SEPARATOR))
      .join(ARRAY_SEPARATOR);
  }

  return encodeURIComponent(String(value));
};

export const serializeColumnFilters = (value: ColumnFiltersState): string => {
  return value.map((filter) => `${filter.id}${KEY_VALUE_SEPARATOR}${serializeValue(filter.value)}`).join(',');
};
